import initializeCarousel from '../carousel';
import matchElementHeights from '../util/matchElementHeights';

function getOverlayWidth(screenWidth) {
  switch (true) {
    case screenWidth <= 1279:
      return 65;
    case screenWidth <= 1599:
      return 60;
    default:
      return 55;
  }
}

export default {
  init() {
    // reviews carousel go!
    initializeCarousel();

    // set review item heights to match
    matchElementHeights('.review-item-text-wrapper');

    // fix for Edge SVG clip-path for banner overlay
    const isEdge =
      window.navigator.userAgent.indexOf('Edge') > -1 ? true : false;

    if (isEdge) {
      const screenWidth = window.innerWidth;

      // sizes below lg don't use clip-path
      if (screenWidth <= 1023) return;

      const overlayWidth = getOverlayWidth(screenWidth);

      const overlayEls = document.querySelectorAll('.home-banner-overlay');

      [].forEach.call(overlayEls, el =>
        el.setAttribute('width', `${overlayWidth}%`)
      );
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js